// extracted by mini-css-extract-plugin
module.exports = {"root":"BuildingTypes_root__2sgzi","containerWrapper":"BuildingTypes_containerWrapper__3LhzB"};